import { GAMES } from '@/constants/GAMES'
import { GLBModel } from '@/scene/GLBModel'
import type { AbstractModel } from '@/scene/AbstractModel'
import { normalizeAmbientFishConfigs } from '@/scene/SceneProps'
import { getLoadedModel, isModelLoaded, isModelSettled, preloadModel } from '@/lib/gltf-cache'

// TODO: оптимизировать GLB-модели через Draco/meshopt компрессию.
// Сейчас cleaner.glb весит около 4МБ, что неприемлемо для мобильного интернета.
// Прогон через `gltf-transform optimize` или `gltfpack` уменьшит размеры в 5-10 раз.
//
// TODO: на статическом хостинге отдать GLB с Cache-Control:
// public, max-age=31536000, immutable. При поддержке сервера включить br/gzip.

function modelUrl(model: AbstractModel): string | null {
  return model instanceof GLBModel ? model.url : null
}

export function getGameAssetUrls(gameId: string): string[] {
  const game = GAMES[gameId]
  if (!game) return []

  const urls = [
    game.weaponModel,
    ...game.garbageModels,
    ...(game.environmentDecor?.map(item => item.model) ?? []),
    ...normalizeAmbientFishConfigs(game.ambientFish).flatMap(cfg => cfg.models.map(fish => fish.model)),
  ]
    .map(modelUrl)
    .filter((url): url is string => Boolean(url))

  return Array.from(new Set(urls))
}

export function preloadGameAssets(gameId: string): void {
  const assets = getGameAssetUrls(gameId)
  if (!assets.length) {
    console.warn('[preload] no GLB assets defined for game:', gameId)
    return
  }

  assets.forEach((url) => {
    preloadModel(url).then(
      () => {},
      (error) => console.error('[preload] failed:', url, error),
    )
  })
}

export function getPreloadProgress(gameId: string): number {
  const assets = getGameAssetUrls(gameId)
  if (!assets.length) return 1

  const done = assets.filter(isModelSettled).length
  return done / assets.length
}

export function isGameAssetsLoaded(gameId: string): boolean {
  const assets = getGameAssetUrls(gameId)
  // Ошибка одной GLB не должна держать пользователя на вечном лоадере.
  // Если модель не скачалась, GLBModel залогирует ошибку и вернёт null-модель,
  // а сцена продолжит работу настолько, насколько сможет.
  return assets.length === 0 || assets.every(isModelSettled)
}

export { getLoadedModel, isModelLoaded, preloadModel }
